module.exports = __webpack_public_path__ + "static/media/Icon open-person.5a4abdbd.svg";